import { useQuery } from 'react-query';
import { getFlexRequestHistory } from 'RestAPIs/flex-history';

const useGetFlexRequestHistory = (processInstanceId: string) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['flexRequestHistory', 'list', processInstanceId],
    async () => {
      const { data } = await getFlexRequestHistory(processInstanceId);
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetFlexRequestHistory;
